module.exports = __webpack_public_path__ + "static/media/image5.a2b2e959.png";